import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ChangePasswordService } from "../core/services/change-password.service";
import { RoutingConstants } from "../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { AuthService } from "src/app/core/services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { JwtDTO } from "../core/models/jwt-dto";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  password;
  public routing = RoutingConstants.changePassword;
  public showChPassword: boolean = true;
  public showChNewPassword: boolean = true;
  public showChNewPasswordConfirm: boolean = true;

  @ViewChild("infoSwal")
  public readonly infoSwal!: SwalComponent;

  constructor(
    private changePasswordService: ChangePasswordService,
    private toastrAlertService: ToastrAlertService,
    private tokenService: TokenService,
    private commonService: CommonService,
    private router: Router,
    private translateService: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.password = new FormGroup({
      chNewPassword: new FormControl("", [Validators.required]),
      chNewPasswordConfirm: new FormControl("", [Validators.required]),
      chPassword: new FormControl("", [Validators.required]),
      usId: new FormControl(this.tokenService.getUserName()),
    });
  }

  validatePassword(): boolean {
    if (
      this.password.value.chNewPassword !==
      this.password.value.chNewPasswordConfirm
    ) {
      let message = this.translateService.instant(
        "messages.passwordConfirmationNotMatch"
      );
      this.toastrAlertService.toastrFail(message);
      return false;
    }
    this.password.value.chNewPassword =
      this.password.value.chNewPassword.normalize("NFKC");
    this.password.value.chNewPasswordConfirm =
      this.password.value.chNewPasswordConfirm.normalize("NFKC");
    return true;
  }

  onUpdate() {
    this.changePasswordService.changePassword(this.password.value).subscribe(
      (data) => {
        this.infoSwal.fire().then((result) => {
          if (result.isConfirmed) {
            this.onLogout();
          }
        });
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onLogout() {
    const dto: JwtDTO = new JwtDTO(this.tokenService.getToken());
    this.authService.logout(dto).subscribe(
      (data) => {
        this.tokenService.logOut();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.password.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.validatePassword()) {
        this.onUpdate();
      }
    }
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  changeView(type: string) {
    switch (type) {
      case 'chPassword':
        this.showChPassword = !this.showChPassword;
        break;
      case 'chNewPassword':
        this.showChNewPassword = !this.showChNewPassword;
        break;
      case 'chNewPasswordConfirm':
        this.showChNewPasswordConfirm = !this.showChNewPasswordConfirm;
        break;
      default:
        this.toastrAlertService.toastrFail('Error');
    }
  }
}
